<template>
  <div style="height: 100%">
    <GmapMap
      v-if="apl.center"
      :center="center"
      :zoom.sync="zoom"
      map-type-id="roadmap"
      style="width: 100%; height: 100%"
      :options="{ styles: mapStyles }"
      @click="infoClosed"
      @zoom_changed="zoomChanged"
      ref="map">
      <gmap-cluster :max-zoom="cluster ? 16 : 1" :ignore-hidden="true">
        <template v-for="marker in markers">
          <GmapMarker
            :key="marker._id + 'marker'"
            :position="{ lat: marker.lat, lng: marker.lng }"
            :animation="search && search._id === marker._id ? 1 : 0"
            :visible="(filters.includes(`${marker.category} - ${marker.status}`) || marker.status_id === null) && ((categorii.includes(marker.category) || marker.category_id === null))"
            :clickable="true"
            @click="markerClicked(marker)"
            :icon="{
              url: getIcon(marker.status_id ? marker.status_id.icon : null),
              scaledSize: {
                width: 36 * (marker.status_id ? getScale(marker) : 2),
                height: 64 * (marker.status_id ? getScale(marker) : 2)
              },
              origin: { x: 0, y: 0 },
              anchor: {
                x: 36 * (marker.status_id ? getScale(marker) : 2) / 2,
                y: 64 * (marker.status_id ? getScale(marker) : 2)
              }
            }"
          />
        </template>
      </gmap-cluster>
      <GmapPolygon :paths="decodePath(apl)" :options="polyOptions(apl)" v-if="poly" @click="infoClosed" />
      <gmap-info-window
        :position="infoPosition"
        :opened="infoOpen"
        @closeclick="infoClosed"
        :options="{
          pixelOffset: {
            width: 0,
            height: selectedMarker ? -1 * 60 * (selectedMarker.status_id ? selectedMarker.status_id.icon.scale : 2) : -35
          }
        }">
        <v-card v-if="selectedMarker" class="ma-0" outlined style="overscroll-behavior: contain">
          <v-list-item class="px-0">
            <v-list-item-avatar height="64" class="pa-2">
              <v-img :src="getIcon(selectedMarker.status_id ? selectedMarker.status_id.icon : null)" contain></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="subtitle-2" style="overflow: visible; white-space: normal">
                {{ selectedMarker.address }}
              </v-list-item-title>
              <v-list-item-subtitle style="overflow: visible; white-space: normal">
                {{ selectedMarker.category_id ? selectedMarker.category_id.name : selectedMarker.category }}
                -
                {{ selectedMarker.status_id ? selectedMarker.status_id.name : selectedMarker.status }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card-text class="px-0">
              <v-tabs>
                <v-tab v-for="(corp, index) in corpuri" :key="index">
                  {{ corp.adresa }}
                </v-tab>
                <v-tab-item v-for="(corp, index) in corpuri" :key="index">
                  <template v-if="corp.poze.length">
                    <v-carousel
                      cycle
                      :height="$vuetify.breakpoint.name === 'xs' ? '20vh' : '50vh'"
                      hide-delimiter-background
                      progress
                      progress-color="secondary"
                      show-arrows-on-hover>
                      <v-carousel-item v-for="picNo in corp.poze" :key="picNo">
                        <v-img
                          :lazy-src="getPicURL(corp, index, picNo, true)"
                          :src="getPicURL(corp, index, picNo)"
                          contain
                          height="100%">
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="primary"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-carousel-item>
                    </v-carousel>
                  </template>
                </v-tab-item>
              </v-tabs>
          </v-card-text>
        </v-card>
      </gmap-info-window>
    </GmapMap>
    <v-sheet color="white" elevation="1" max-height="80vh" max-width="50vw" style="position: fixed; top: 150px; left: 12px; overflow-y: auto; overflow-x: hidden">
      <!-- <v-card flat> -->
        <v-card-title class="py-1 px-0">
          <span v-if="apl" style="padding-left: 8px; max-width: calc(100% - 24px - 28px - 8px - 4px); white-space: nowrap" class="subtitle-2">{{ apl.name }}, {{ apl.county }}</span>
          <v-spacer>
          </v-spacer>
          <v-btn icon @click="toggleMinimize" small>
            <v-icon small>{{ minimized ? 'mdi-window-maximize' : 'mdi-window-minimize' }}</v-icon>
          </v-btn>
          <!-- <v-btn icon @click="toggleFullscreen" small>
            <v-icon small>{{ fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}</v-icon>
          </v-btn> -->
        </v-card-title>
        <v-card-text v-show="!minimized" style="overscroll-behavior: contain">
          <v-list dense subheader>
            <v-subheader>Categorii</v-subheader>
            <v-list-item v-for="categorie in categories" :key="categorie._id">
              <v-list-item-icon>
                <v-img
                  :src="getIcon(categorie.icon)"
                  lazy-src="data:image/png;base64,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"
                  width="24"
                  contain>
                </v-img>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title :title="categorie.name">
                  {{ categorie.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ numbersCategories[categorie.value] }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch dense :color="categorie.color" v-model="categorii" :value="categorie.value"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-subheader>Filtre</v-subheader>
            <v-list-item v-for="status in statusesForSelectedCategories" :key="status._id">
              <v-list-item-icon>
                <v-img
                  :src="getIcon(status.icon)"
                  lazy-src="data:image/png;base64,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"
                  width="24"
                  contain>
                </v-img>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title :title="`${status.category_id.name} - ${status.name}`">
                  <!-- {{ status.category_id.name }} - {{ status.name }} -->
                  {{ status.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ numbersFilters[status.category_id.value][status.value] }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch dense :color="status.color" v-model="filters" :value="`${status.category_id.value} - ${status.value}`"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-subheader>Optiuni</v-subheader>
            <v-list-item>
              <v-list-item-icon>
                <v-icon :color="apl && apl.borders ? apl.borders.stroke : 'primary'">mdi-vector-polygon</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>PERMIETRU</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch dense v-model="poly" :color="apl && apl.borders ? apl.borders.stroke : 'primary'"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="accent">mdi-circle-multiple-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>GRUPARE</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch dense v-model="cluster" color="accent"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-subheader>Cautare</v-subheader>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="accent">mdi-map-search</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-autocomplete
                  dense
                  single-line
                  return-object
                  v-model="search"
                  :filter="itemFilter"
                  :items="markers"
                  label="Cautare adresa"
                  clearable
                  item-text="name"
                  item-value="name">
                  <template v-slot:item="data">
                    <v-list-item-avatar>
                      <v-img
                        :src="getIcon(data.item.status_id ? data.item.status_id.icon : null)"
                        lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA8CAYAAAA34qk1AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAABvpJREFUeJzNm3lsFFUcgGk5yiVdSkHlCEVAbkGDRyISjXIokSMEPEA5REQxIooma0NQrGIoBiVexPgHChiCIphQUMQoaGUhHI0BkUNAwilIodgWKMXvx77VYZk38+bt0PJLvjQtM+/9vp1371CjRhVGLLa+HtwCUfgKYvATLITnoTtkVmVOoQbJ14TblVQZXNBQDjsgHzpCWnXnbhwk2wCmwt8egm6chMXQq7odfIMk68BLUBpQ0skRmAmR6vbRBsn1heMpSCaohGXQtVqFonlv13X7u0ouVUmn7Ga4t6r9RLALzIKhLpKtfQYeW3bDoKoS7ABvw3Z4Axq4iEYDJH8W9sEmKIID6gnqrt8LA6+kYCZMg1NQCs/oriWR7w2a4jp4ArJc7m8CY2AplLjc/xd0vxKSHWEzXFCSYyDdQ/SAh6QkPglqmdTNdfXhVdjv0oxbhCWYDg/DSSV5Bib4SGZ4ND2ZT3vb5MJ9jWFGLD7HJspbLR+EvWGNi5IZ8CZUKMlK1XQ9nwQVt9FIloXRtyijB/ziKPe1mO0qCpnGMF8JJpgL9QwS6aoRnW2d0OV1yLp5FlSoD/CuwIUgkwWLkyQPQ2vDJDq4SB6TJx04Ge96ZA09IRZfIxdI0za+GZlGMC9JUprsuAAJRFxEZRTW9mvbkBYCD8FpGG10EzK1IS9JUtgCDQMmUJwk+paNSID6JsMauN73YmTGq1HVKSm/P2hRcaFDUvrRWCsD8/rSVTPu63khMs1gj8vT3CoLBYuK5zhEpVkNtrYIVq/33IzM+y6SQp5lhXc75lJpxv2tMg8zkGkLJS6S5XCrTZlqRNzvEO0Xdt6BA5mPNE/zT2nStuUi96Gj6VbNjkMXiNSHoxpRGW1r25aNXB/4B87BqDDyzcldnQERaArZkAn+OSIySiMprEklKbV6maee6is2ZSBRHzrDJFgCm2A77IZd8BtsgE9gKDSHy+drlxWQk59TEVWyveEUfBxQsBk8BxuhGM4acAb2QR5cOp+qzbNO9Neo5pgkgKgckL0LP5qsc0kwC6bAH4ZyOuQDausUPe0hegRapSKqZOWMdlXMZYPtEKwNg1WzTEXQyU5olRCt9BCVf3syBFFZjw6BmzWSXWABlCY1w8OqL4r8ISi3kF0Hdf2eqFAkW7YQZOUgu2eSYLoaQLbAXlgEuTAM7oBO0A7aQEforfrtcigJ0G8n+vVRQTbdr0PNEGT/mwZUUx0LM+FRJWV0UsB1jVUzLzKU3Syin/qICnIY9lQYso5kM9XTshrsuC9NPeUCA9EyEe0F5w1k5cxoCjQKSzaMQKK16oeesonDr5UGoonTv29gJGSbJMJ1adAUekYNjmEsZXvBMU9RlUyWWteayDr3qYWQDxNhBAyHR6Lxfe10WAI7oQC6OZOLrHiveciyi3xFlWx7C1k/1sMAt8QQvR9uCFF0hNdIfMnFJNVOffomfdaLmHqy2pUQku0hD+qEJCoD2w4jUSUrffYeWAonAshJa/gAjL7aQ7AhFEEoG3JkankMSmWeN5N0Heih+p/0OTkd/BIWReMnEpOhH1j1NyQLoBCutbJLCoS+1YiuD6N860BwDlyACWGUh9BqjWh+GOVbB4IvK9GNqY7COfEN+QbNEvDGsHK2CuTGwnkl+1gqZSHTVjMYpXR4EEogNwxKleiKVMpCaBCcSJKU3VDVvwqQHMgNgdNKVH5q96t+gdB0l6e5PMx8rQOx4VCmRIXHbcpRU8t3SZKyJOzmeSMV3gShfvOlqWeco48KC2zKUf3zkENSNugzTBLoA8sgx6Zi06D8aQ5JYUvQMtR2LTfpaa4C/6/81aplPnwNRruUoEG5abA4SbQ4aDk58ePNXQ7JbWD+7QKV9oQj8AO0DJqAQfnZsCdJVLjsVR5d5MSPYmY7JPfIli1oIjUhFyqlSUm/DWzjXf7opP6ZwHg5iNRtcFxJHoD+0pRtkrkOtqsEDsIAMHplxqfcFrDLRVJoalJGTvwoplBJiuyAHLcT+gBJ3QclKgn5OQv8v1XWlyf9f4lGUp6w7/coajp5QY2uB2FgSpIqsXQY75jvpCnvVnvJ9gHL6gQrNU32YqvxK0P1yxFqnpTdSg+r5qpJMANmQIUjqQrV/N6B/qA9NJMWAM/C7+qDcpMU1vpIylTSF7bCXBlxQxFMSvYa+ELzNIoj8U30Z2punAhPw1Q1TW2Fcg/BBLN9RGVhsBBGQqCXR4LKtoKlHk0vVe70Ec1Wslf+XXuSaQmfw7mQJbdFQhjRQ41IfLLPj/y/80gV6bcvVreXNkjuATgagqhMN1fvfw6QIMEmsCBy6YgcBDkcM3rH8KoIku0MK+CsoaAMaAsjIZ0AVnmQePNIfFpZq+nD8rdVMBBCfwlSF/8C3QjwwqUt65wAAAAASUVORK5CYII="
                        width="24"
                        contain>
                      </v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <!-- <v-list-item-title v-html="data.item.name"></v-list-item-title> -->
                      <v-list-item-subtitle v-html="data.item.address"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="data.item.status_id ? data.item.status_id.name : data.item.status"></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
    </v-sheet>
  </div>
</template>

<script>
import SERVER_URL from '@/config'
import { gmapApi } from 'vue2-google-maps'
// import mapStyles from '@/mapstyles/default.json'

export default {
  name: 'avz-apl-map',

  props: {
    aplid: {
      type: String,
      required: true
    }
  },

  data: () => ({
    sheetHeight: 20,
    minimized: false,
    fullscreen: false,
    search: null,
    options: true,
    poly: true,
    cluster: false,
    apl: {},
    markers: [],
    statuses: [],
    categories: [],

    categorii: [],
    filters: [],
    numbersFilters: {},
    numbersCategories: {},
    // mapStyles,
    center: null,
    zoom: 12,
    mapZoom: 12,
    infoPosition: { lat: 0, lng: 0 },
    infoOpen: false,
    selectedMarker: null,

    detailsLoaded: false,

    corpuri: null,

    selectedMapStyle: 'default',
    availableMapStyles: ['default', 'pnl', 'psd', 'udmr', 'other']
  }),

  watch: {
    search (value) {
      if (value) {
        this.minimized = true
        this.center = { lat: value.lat, lng: value.lng }
        this.zoom = 20
      } else {
        this.center = this.apl.center
        this.zoom = 12
      }
    }
  },

  computed: {
    google: gmapApi,
    decodePath () {
      return apl => {
        if (this.google && apl.borders) {
          const poly = this.google.maps.geometry.encoding.decodePath(apl.borders.polyString)

          return poly
        } else {
          return []
        }
      }
    },
    polyOptions () {
      return apl => ({
        fillColor: apl && apl.borders ? apl.borders.fill : 'blue',
        strokeColor: apl && apl.borders ? apl.borders.stroke : 'blue'
      })
    },

    statusesForSelectedCategories () {
      return this.statuses.filter(status => this.categorii.includes(status.category_id.value))
    },

    mapStyles () {
      return require(`../mapstyles/${this.selectedMapStyle}.json`) // the module request
    }
  },

  methods: {
    getScale (marker) {
      if (this.mapZoom > 17) return marker.status_id.icon.scale * 1.25
      else if (this.mapZoom > 14) return marker.status_id.icon.scale * 0.75
      else return marker.status_id.icon.scale * 0.50
    },
    zoomChanged ($event) {
      this.mapZoom = $event
    },
    itemFilter (item, queryText, itemText) {
      const textOne = item.name.toLowerCase()
      const textTwo = item.address.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1
    },
    toggleMinimize () {
      this.fullscreen = false
      this.minimized = !this.minimized
    },
    toggleFullscreen () {
      this.minimized = false
      this.fullscreen = !this.fullscreen
    },
    async getAPL () {
      const apl = await this.$store.dispatch('getAPL', this.aplid)
      this.apl = Object.freeze(apl)
      this.center = apl.center

      this.$store.commit('setCurrentAPL', apl)
    },
    async fetchMarkers () {
      const markers = await this.$store.dispatch('fetchAllMarkers', { apl_id: this.aplid })
      this.markers = Object.freeze([...markers])
      markers.forEach(marker => {
        if (this.numbersFilters?.[marker.category]?.[marker.status]) {
          this.numbersFilters[marker.category][marker.status]++
        } else {
          if (marker.category) {
            if (this.numbersFilters[marker.category]) {
              this.numbersFilters[marker.category][marker.status] = 1
            } else {
              this.numbersFilters[marker.category] = {
                [marker.status]: 1
              }
            }
          }
        }

        if (this.numbersCategories[marker.category]) {
          this.numbersCategories[marker.category]++
        } else {
          this.numbersCategories[marker.category] = 1
        }
      })
    },
    async fetchStatuses () {
      const statuses = await this.$store.dispatch('fetchAllStatuses', { apl_id: this.aplid })
      this.statuses = Object.freeze([...statuses])
      this.statuses.forEach(status => {
        this.filters.push(`${status.category_id.value} - ${status.value}`)

        if (this.numbersFilters[status.category_id.value]) {
          this.numbersFilters[status.category_id.value][status.value] = 0
        } else {
          this.numbersFilters[status.category_id.value] = {
            [status.value]: 0
          }
        }
      })
    },
    async fetchCategories () {
      const categories = await this.$store.dispatch('fetchAllCategories', { apl_id: this.aplid })
      this.categories = Object.freeze([...categories])
      this.categories.forEach(category => {
        this.categorii.push(category.value)
        this.numbersCategories[category.value] = 0
      })
    },

    getIcon (icon, type = 'icon') {
      const noFile = type === 'logo' ? '/logos/logo-tud-mic.png' : '/icons/apl-icon-orphan.png'
      return SERVER_URL + (icon && icon.url ? icon.url : noFile)
    },

    getPicURL (corp, index, picNo, preview = false) {
      if (preview) {
        return `${SERVER_URL}/temp/img/${picNo}`
      } else {
        return `${SERVER_URL}/temp/img/${picNo}`
      }
    },

    infoClosed () {
      this.infoOpen = false
      this.infoPosition = { lat: 0, lng: 0 }
      this.selectedMarker = null
    },
    markerClicked (marker) {
      this.infoPosition = { lat: marker.lat, lng: marker.lng }
      this.selectedMarker = marker
      this.infoOpen = true

      this.corpuri = tempItems.filter(corp => corp.id === marker.unique)

      // this.corpuri.forEach((corp, index) => {
      //   this.corpHasPics(corp, index)
      // })

      // this.getDetails()
    },

    async getDetails () {
      // const details = await this.$store.dispatch('fetchDetails', this.selectedMarker._id)
      // const properties = await this.$store.dispatch('fetchProperties4Marker', this.selectedMarker)

      // console.log(details, properties)
    },

    async corpHasPics (corp, index) {
      const result = await this.$store.dispatch('fetchPics', { id: corp.poza_fatada })

      this.$set(corp, 'poze', result.length)
    },

    getMapStyleIcon (item) {
      return SERVER_URL + '/mapstylesicons/' + item + '.png'
    }
  },

  async created () {
    await this.getAPL()
    await this.fetchStatuses()
    await this.fetchCategories()
    await this.fetchMarkers()
  },

  beforeDestroy () {
    this.$store.commit('setCurrentAPL', null)
  }
}

/* eslint-disable quote-props */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
const tempItems = [
  {
    "id": "OZ1",
    "adresa": "Bloc P1, Sc. C, Bulevardul Theodor Pallady, Nr. 21",
    "poze": [
      "OZ1_obiectiv_001.jpg",
      "OZ1_obiectiv_002.jpg",
      "OZ1_obiectiv_003.jpg",
      "OZ1_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ2",
    "adresa": "Bloc P1, Sc. B, Bulevardul Theodor Pallady, Nr. 21",
    "poze": [
      "OZ2_obiectiv_001.jpg",
      "OZ2_obiectiv_002.jpg",
      "OZ2_obiectiv_003.jpg",
      "OZ2_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ3",
    "adresa": "Bloc P1, Sc. A, Bulevardul Theodor Pallady, Nr. 21",
    "poze": [
      "OZ3_obiectiv_001.jpg",
      "OZ3_obiectiv_002.jpg",
      "OZ3_obiectiv_003.jpg",
      "OZ3_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ4",
    "adresa": "Bloc P4, Sc. -, Bulevardul Theodor Pallady, Nr. 19",
    "poze": [
      "OZ4_obiectiv_001.jpg",
      "OZ4_obiectiv_002.jpg",
      "OZ4_obiectiv_003.jpg",
      "OZ4_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ5",
    "adresa": "Bloc P2, Sc. 2, Bulevardul 1 Decembrie 1918, Nr. 53",
    "poze": [
      "OZ5_obiectiv_001.jpg",
      "OZ5_obiectiv_002.jpg",
      "OZ5_obiectiv_003.jpg",
      "OZ5_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ6",
    "adresa": "Bloc P2, Sc. 1, Bulevardul 1 Decembrie 1918, Nr. 53",
    "poze": [
      "OZ6_obiectiv_001.jpg",
      "OZ6_obiectiv_002.jpg",
      "OZ6_obiectiv_003.jpg",
      "OZ6_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ7",
    "adresa": "Bloc P3, Sc. B, Strada Armenis, Nr. 2",
    "poze": [
      "OZ7_obiectiv_001.jpg",
      "OZ7_obiectiv_002.jpg",
      "OZ7_obiectiv_003.jpg",
      "OZ7_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ8",
    "adresa": "Bloc P3, Sc. A, Strada Armenis, Nr. 2",
    "poze": [
      "OZ8_obiectiv_001.jpg",
      "OZ8_obiectiv_002.jpg",
      "OZ8_obiectiv_003.jpg",
      "OZ8_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ9",
    "adresa": "Bloc V10, Sc. 1, Bulevardul Theodor Pallady, Nr. 23",
    "poze": [
      "OZ9_obiectiv_001.jpg",
      "OZ9_obiectiv_002.jpg",
      "OZ9_obiectiv_003.jpg",
      "OZ9_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ10",
    "adresa": "Bloc V10, Sc. 2, Bulevardul Theodor Pallady, Nr. 23",
    "poze": [
      "OZ10_obiectiv_001.jpg",
      "OZ10_obiectiv_002.jpg",
      "OZ10_obiectiv_003.jpg",
      "OZ10_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ11",
    "adresa": "Bloc V10, Sc. 3, Bulevardul Theodor Pallady, Nr. 23",
    "poze": [
      "OZ11_obiectiv_001.jpg",
      "OZ11_obiectiv_002.jpg",
      "OZ11_obiectiv_003.jpg",
      "OZ11_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ12",
    "adresa": "Bloc V10, Sc. 4, Bulevardul Theodor Pallady, Nr. 23",
    "poze": [
      "OZ12_obiectiv_001.jpg",
      "OZ12_obiectiv_002.jpg",
      "OZ12_obiectiv_003.jpg",
      "OZ12_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ13",
    "adresa": "Bloc V10, Sc. 5, Bulevardul Theodor Pallady, Nr. 23",
    "poze": [
      "OZ13_obiectiv_001.jpg",
      "OZ13_obiectiv_002.jpg",
      "OZ13_obiectiv_003.jpg",
      "OZ13_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ14",
    "adresa": "Bloc V11, Sc. 1, Bulevardul Theodor Pallady, Nr. 25",
    "poze": [
      "OZ14_obiectiv_001.jpg",
      "OZ14_obiectiv_002.jpg",
      "OZ14_obiectiv_003.jpg",
      "OZ14_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ15",
    "adresa": "Bloc V11, Sc. 2, Bulevardul Theodor Pallady, Nr. 25",
    "poze": [
      "OZ15_obiectiv_001.jpg",
      "OZ15_obiectiv_002.jpg",
      "OZ15_obiectiv_003.jpg",
      "OZ15_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ16",
    "adresa": "Bloc V11, Sc. 3, Bulevardul Theodor Pallady, Nr. 25",
    "poze": [
      "OZ16_obiectiv_001.jpg",
      "OZ16_obiectiv_002.jpg",
      "OZ16_obiectiv_003.jpg",
      "OZ16_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ17",
    "adresa": "Bloc V11, Sc. 4, Bulevardul Theodor Pallady , Nr. 25",
    "poze": [
      "OZ17_obiectiv_001.jpg",
      "OZ17_obiectiv_002.jpg",
      "OZ17_obiectiv_003.jpg",
      "OZ17_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ18",
    "adresa": "Bloc J38, Sc. A, Bulevardul 1 Decembrie 1918, Nr. 51",
    "poze": [
      "OZ18_obiectiv_001.jpg",
      "OZ18_obiectiv_002.jpg",
      "OZ18_obiectiv_003.jpg",
      "OZ18_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ19",
    "adresa": "Bloc J38, Sc. B, Bulevardul 1 Decembrie 1918, Nr. 51",
    "poze": [
      "OZ19_obiectiv_001.jpg",
      "OZ19_obiectiv_002.jpg",
      "OZ19_obiectiv_003.jpg",
      "OZ19_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ20",
    "adresa": "Bloc J38, Sc. C, Bulevardul 1 Decembrie 1918, Nr. 51",
    "poze": [
      "OZ20_obiectiv_001.jpg",
      "OZ20_obiectiv_002.jpg",
      "OZ20_obiectiv_003.jpg",
      "OZ20_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ21",
    "adresa": "Bloc J38, Sc. D, Bulevardul 1 Decembrie 1918, Nr. 51",
    "poze": [
      "OZ21_obiectiv_001.jpg",
      "OZ21_obiectiv_002.jpg",
      "OZ21_obiectiv_003.jpg",
      "OZ21_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ22",
    "adresa": "Bloc J38, Sc. E, Bulevardul 1 Decembrie 1918, Nr. 51",
    "poze": [
      "OZ22_obiectiv_001.jpg",
      "OZ22_obiectiv_002.jpg",
      "OZ22_obiectiv_003.jpg",
      "OZ22_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ23",
    "adresa": "Bloc J38, Sc. F, Bulevardul 1 Decembrie 1918, Nr. 51",
    "poze": [
      "OZ23_obiectiv_001.jpg",
      "OZ23_obiectiv_002.jpg",
      "OZ23_obiectiv_003.jpg",
      "OZ23_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ24",
    "adresa": "Bloc J1, Sc. A, Strada Armenis, Nr. 4",
    "poze": [
      "OZ24_obiectiv_001.jpg",
      "OZ24_obiectiv_002.jpg",
      "OZ24_obiectiv_003.jpg",
      "OZ24_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ25",
    "adresa": "Bloc J1, Sc. B, Strada Armenis, Nr. 4",
    "poze": [
      "OZ25_obiectiv_001.jpg",
      "OZ25_obiectiv_002.jpg",
      "OZ25_obiectiv_003.jpg",
      "OZ25_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ26",
    "adresa": "Bloc J1, Sc. C, Strada Armenis, Nr. 4",
    "poze": [
      "OZ26_obiectiv_001.jpg",
      "OZ26_obiectiv_002.jpg",
      "OZ26_obiectiv_003.jpg",
      "OZ26_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ27",
    "adresa": "Bloc J1, Sc. D, Strada Armenis, Nr. 4",
    "poze": [
      "OZ27_obiectiv_001.jpg",
      "OZ27_obiectiv_002.jpg",
      "OZ27_obiectiv_003.jpg",
      "OZ27_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ28",
    "adresa": "Bloc J3, Sc. F, Strada Armenis, Nr. 6",
    "poze": [
      "OZ28_obiectiv_001.jpg",
      "OZ28_obiectiv_002.jpg",
      "OZ28_obiectiv_003.jpg",
      "OZ28_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ29",
    "adresa": "Bloc J3, Sc. E, Strada Armenis, Nr. 6",
    "poze": [
      "OZ29_obiectiv_001.jpg",
      "OZ29_obiectiv_002.jpg",
      "OZ29_obiectiv_003.jpg",
      "OZ29_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ30",
    "adresa": "Bloc J3, Sc. D, Strada Armenis, Nr. 6",
    "poze": [
      "OZ30_obiectiv_001.jpg",
      "OZ30_obiectiv_002.jpg",
      "OZ30_obiectiv_003.jpg",
      "OZ30_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ31",
    "adresa": "Bloc J3, Sc. C, Strada Armenis, Nr. 6",
    "poze": [
      "OZ31_obiectiv_001.jpg",
      "OZ31_obiectiv_002.jpg",
      "OZ31_obiectiv_003.jpg",
      "OZ31_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ32",
    "adresa": "Bloc J3, Sc. B, Strada Armenis, Nr. 6",
    "poze": [
      "OZ32_obiectiv_001.jpg",
      "OZ32_obiectiv_002.jpg",
      "OZ32_obiectiv_003.jpg",
      "OZ32_obiectiv_004.jpg",
      "OZ32_obiectiv_005.jpg"
    ]
  },
  {
    "id": "OZ33",
    "adresa": "Bloc J3, Sc. A, Strada Armenis, Nr. 6",
    "poze": [
      "OZ33_obiectiv_001.jpg",
      "OZ33_obiectiv_002.jpg",
      "OZ33_obiectiv_003.jpg",
      "OZ33_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ34",
    "adresa": "Bloc J5, Sc. H, Strada Armenis, Nr. 8-10",
    "poze": [
      "OZ34_obiectiv_001.jpg",
      "OZ34_obiectiv_002.jpg",
      "OZ34_obiectiv_003.jpg",
      "OZ34_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ35",
    "adresa": "Bloc J5, Sc. G, Strada Armenis, Nr. 8-10",
    "poze": [
      "OZ35_obiectiv_001.jpg",
      "OZ35_obiectiv_002.jpg",
      "OZ35_obiectiv_003.jpg",
      "OZ35_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ36",
    "adresa": "Bloc J5, Sc. F, Strada Armenis, Nr. 8-10",
    "poze": [
      "OZ36_obiectiv_001.jpg",
      "OZ36_obiectiv_002.jpg",
      "OZ36_obiectiv_003.jpg",
      "OZ36_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ37",
    "adresa": "Bloc J5, Sc. E, Strada Armenis, Nr. 8-10",
    "poze": [
      "OZ37_obiectiv_001.jpg",
      "OZ37_obiectiv_002.jpg",
      "OZ37_obiectiv_003.jpg",
      "OZ37_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ38",
    "adresa": "Bloc J5, Sc. D, Strada Armenis, Nr. 8-10",
    "poze": [
      "OZ38_obiectiv_001.jpg",
      "OZ38_obiectiv_002.jpg",
      "OZ38_obiectiv_003.jpg",
      "OZ38_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ39",
    "adresa": "Bloc J5, Sc. C, Strada Armenis, Nr. 8-10",
    "poze": [
      "OZ39_obiectiv_001.jpg",
      "OZ39_obiectiv_002.jpg",
      "OZ39_obiectiv_003.jpg",
      "OZ39_obiectiv_004.jpg",
      "OZ39_obiectiv_005.jpg"
    ]
  },
  {
    "id": "OZ40",
    "adresa": "Bloc J5, Sc. B, Strada Armenis, Nr. 8-10",
    "poze": [
      "OZ40_obiectiv_001.jpg",
      "OZ40_obiectiv_002.jpg",
      "OZ40_obiectiv_003.jpg",
      "OZ40_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ41",
    "adresa": "Bloc J5, Sc. A, Strada Armenis, Nr. 8-10",
    "poze": [
      "OZ41_obiectiv_001.jpg",
      "OZ41_obiectiv_002.jpg",
      "OZ41_obiectiv_003.jpg",
      "OZ41_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ41",
    "adresa": "-",
    "poze": [
      "OZ41_obiectiv_001.jpg",
      "OZ41_obiectiv_002.jpg",
      "OZ41_obiectiv_003.jpg",
      "OZ41_obiectiv_004.jpg"
    ]
  },
  {
    "id": "OZ42",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ43",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ44",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ45",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ46",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ47",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ48",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ49",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ50",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ51",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ52",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ53",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ54",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ56",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ57",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ58",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ59",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ60",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ61",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ62",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ63",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ64",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ65",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ66",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ67",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ68",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ69",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ70",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ71",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ72",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ73",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ74",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ75",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ76",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ77",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ78",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ79",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ80",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ81",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ82",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ83",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ84",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ85",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ86",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ87",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ88",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ89",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ90",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ91",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ92",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ93",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ94",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ95",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ96",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ97",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ98",
    "adresa": "-",
    "poze": []
  },
  {
    "id": "OZ99",
    "adresa": "-",
    "poze": []
  }
]
</script>
